<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div>
      <mrc_ess_iconGroup :is_disabled="disabled"
                         :show_del="false"
                         @handleReturn="handleReturn"
                         @handleEdit="handleEdit"
                         @handleDel="handleDel"></mrc_ess_iconGroup>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_multiText :error-messages="
                  $errors(
                    'params',
                    'org_level_name',
                    requiredRule.concat(nocharacter)
                  )
                "
                                 :readonly="disabled"
                                 style="width:100%"
                                 :label="$t('label_Department_name') + '*'"
                                 v-model="params.org_level_name"
                                 :isNational="judegNational('org_level_name')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_multiText :error-messages="
                  $errors(
                    'params',
                    'org_level_shortcode',
                    requiredRule.concat(nocharacter)
                  )
                "
                                 :readonly="disabled"
                                 style="width:100%"
                                 :label="$t('label_Short_code') + '*'"
                                 v-model="params.org_level_shortcode"
                                 :isNational="judegNational('org_level_shortcode')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12"
                   sm="12">
              <!-- <mrc_ess_prompt
                :errMsg="
                  $errors('params', 'org_level_code_parent', requiredRule)
                "
                :disabled="disabled"
                :rules="false"
                :label="$t('label_Higher_office') + '*'"
                :chips="false"
                @getData="params.org_level_leader_uuid = ''"
                :obj="deparentmentParent"
                v-model="params.org_level_code_parent"
              >
              </mrc_ess_prompt> -->
              <mrc_ess_autoComplete :label="$t('label_Higher_office') + '*'"
                                    deptView
                                    :error-messages="
                  $errors('params', 'org_level_code_parent', requiredRule)
                "
                                    :readonly="disabled"
                                    @changeStaff="params.org_level_leader_uuid = ''"
                                    v-model="params.org_level_code_parent"
                                    :prompt_name="deparentmentParent">
              </mrc_ess_autoComplete>
            </v-col>
            <v-col cols="12"
                   sm="12">
              <!-- <mrc_ess_prompt
                :disabled="disabled"
                :rules="false"
                :label="$t('label_Department_head')"
                :chips="false"
                :noDataText="$t('message_please_select_Higher_office')"
                :obj="leaderObj"
                v-model="params.org_level_leader_uuid"
              >
              </mrc_ess_prompt> -->

              <mrc_ess_staffInfo v-model="params.org_level_leader_uuid"
                                 itemText="view_fields"
                                 itemValue="value_field"
                                 :readonly="disabled"
                                 prompt_name="leaderObj"
                                 :label="this.$t('label_Department_head')">
              </mrc_ess_staffInfo>
            </v-col>
            <v-col cols="12"
                   sm="12">
              <!-- <v-text-field :error-messages="
                  $errors(
                    'params',
                    'sequence',
                    requiredRule.concat(between('1-99'))
                  )
                "
                            @input="$v.params.sequence.$touch()"
                            @blur="$v.params.sequence.$touch()"
                            :readonly="disabled"
                            :label="$t('label_The_sorting') + '*'"
                            v-model.number="params.sequence"></v-text-field> -->

              <mrc_ess_NumInput :label="$t('label_The_sorting') + '*'"
                                :error-messages="
                  $errors(
                    'params',
                    'sequence',
                    between('000-999').concat(requiredRule)
                  )
                "
                                v-model.number="params.sequence"
                                :readonly="disabled"></mrc_ess_NumInput>
            </v-col>
          </v-row>
        </v-card-text>
        <mrc_ess_submitBtn @cancel="cancel"
                           v-if="!disabled"
                           :loading="loading"
                           @success="success">
        </mrc_ess_submitBtn>
      </v-card>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
} from 'vuelidate/lib/validators'
import {
  departmentData,
  addDepartment,
  updateDepartment,
  delDepartment,
} from '@/service/api/departmentManage'
export default {
  components: {},
  props: {},
  data () {
    return {
      skLoading: false,
      loading: false,
      disabled: true,
      params: {
        uuid: '',
        sequence: 1,
        org_level_leader_uuid: '',
        org_level_code_parent: '',
        org_level_name: '',
        org_level_shortcode: '',
      },
    }
  },
  validations: {
    params: {
      sequence: {
        required,
        between: between(0, 999),
      },
      org_level_code_parent: {
        required,
      },
      org_level_name: {
        required,
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      org_level_shortcode: {
        required,
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
    },
  },
  created () { },
  async mounted () {
    if (!this.$store.state.iconstatus) {
      this.disabled = false
    }
    await this.national('mrbase_sys_org_levels')
    this.skLoading = true
    const uuid = this.$route.params.uuid || this.$store.state.uuid2
    if (uuid) {
      this.params.uuid = uuid
      const title = this.$store.getters.subPage_name
      await this.getData()
    } else {
      this.disabled = false
    }
    this.skLoading = false
  },
  methods: {
    async getData () {
      const data = await departmentData({ uuid: this.params.uuid })
      if (data.code == 200) {
        this.params.uuid = data.data.uuid
        this.params.sequence = data.data.sequence
        this.params.org_level_leader_uuid = data.data.org_level_leader_uuid
        this.params.org_level_code_parent = data.data.org_level_code_parent
        this.params.org_level_name = data.data.org_level_name
        this.params.org_level_shortcode = data.data.org_level_shortcode
      }
    },
    cancel () {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      })
        .then(() => {
          this.$router.go(-1)
        })
        .catch(() => { })
    },
    async success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.loading = true
      try {
        if (this.params.uuid) {
          const update = await updateDepartment(this.params)
          if (update.code == 200) {
            this.$Message({
              text: this.$t('message_The_operation_was_successful'),
            })
            // this.$router.go(-1)
            this.disabled = !this.disabled
          }
        } else {
          const add = await addDepartment(this.params)
          if (add.code == 200) {
            this.$Message({ text: this.$t('message_added_successfully') })
            this.$router.go(-1)
          }
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    handleReturn () {
      this.$router.go(-1)
    },
    handleEdit () {
      this.disabled = !this.disabled
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') })
        .then(async () => {
          const del = await delDepartment({ uuid: this.params.uuid })
          if (del.code == 200) {
            // this.$store.commit(
            //   'newsTips',
            //   this.$t('message_The_deletion_was_successful')
            // )
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            })
          }
        })
        .catch(() => { })
    },
  },
  computed: {
    leaderObj () {
      return {
        prompt_name: 'dept-leader',
        org_level_code: this.params.org_level_code_parent,
      }
    },
    deparentmentParent () {
      return {
        prompt_name: 'level_dept',
        org_level_code: this.$store.state.orgLevelCode,
      }
    },
  },
  watch: {},
}
</script>

<style scoped></style>
